const initialeState = {
    orderAddress : null,
    billingAddress : null,
    order: null

}

const CommandeReducer = (state=initialeState, action) => {
    switch (action.type) {
        case "SET_ORDER_ADDRESS":
            return {
                ...state,
                orderAddress:  action.data
            }
        case "SET_ORDER":
            return{
                ...state,
                order: action.data
            }
        default:
            return state
    }
}

export default CommandeReducer
